import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: r => require(['../views/Login.vue'], r),
  },
  // 首页
  {
    path: '/index',
    name: 'Index',
    component: r => require(['../views/Index.vue'], r),
  },

  // 协议卡参数设置
  {
    path: '/dataMng',
    name: 'DataMng',
    component: r => require(['../views/patch/DataMng.vue'], r),
  },
  // HJ212参数模板
  {
    path: '/dataTemplate',
    name: 'DataTemplate',
    component: r => require(['../views/patch/DataTemplate.vue'], r),
  },
  // 新发现设备
  {
    path: '/deviceDiscover',
    name: 'DeviceDiscover',
    component: r => require(['../views/patch/DeviceDiscover.vue'], r),
  },
  // 采集点维护
  {
    path: '/deviceMng',
    name: 'DeviceMng',
    component: r => require(['../views/patch/DeviceMng.vue'], r),
  },
  // 采集点监控
  {
    path: '/deviceMonitor',
    name: 'DeviceMonitor',
    component: r => require(['../views/patch/DeviceMonitor.vue'], r),
  },
  // HJ212参数设置
  {
    path: '/deviceParam',
    name: 'DeviceParam',
    component: r => require(['../views/patch/DeviceParam.vue'], r),
  },
  // 数据对接监控
  {
    path: '/thirdMonitor',
    name: 'ThirdMonitor',
    component: r => require(['../views/patch/ThirdMonitor.vue'], r),
  },
  
  
  // 协议卡图形报表
  {
    path: '/dataChart',
    name: 'DataChart',
    component: r => require(['../views/report/DataChart.vue'], r),
  },
  // 协议卡实时地图
  {
    path: '/dataGeoMap',
    name: 'DataGeoMap',
    component: r => require(['../views/report/DataGeoMap.vue'], r),
  },
  // 协议卡采集记录
  {
    path: '/dataRecords',
    name: 'DataRecords',
    component: r => require(['../views/report/DataRecords.vue'], r),
  },
  // HJ212实时地图
  {
    path: '/hJ212GeoMap',
    name: 'HJ212GeoMap',
    component: r => require(['../views/report/HJ212GeoMap.vue'], r),
  },
  // HJ212采集记录
  {
    path: '/hJ212Records',
    name: 'HJ212Records',
    component: r => require(['../views/report/HJ212Records.vue'], r),
  },
  // HJ212图形报表
  {
    path: '/hJ212Stat',
    name: 'HJ212Stat',
    component: r => require(['../views/report/HJ212Stat.vue'], r),
  },
  // HJ212图形报表
  {
    path: '/hJ212Alarm',
    name: 'HJ212Alarm',
    component: r => require(['../views/report/HJ212Alarm.vue'], r),
  },
  
  
  // 新增用户
  {
    path: '/userNew',
    name: 'UserNew',
    component: r => require(['../views/list/UserNew.vue'], r),
  },
  // 修改用户
  {
    path: '/userList',
    name: 'UserList',
    component: r => require(['../views/list/UserList.vue'], r),
  },
  // 新增机构
  {
    path: '/deptAdd',
    name: 'DeptAdd',
    component: r => require(['../views/list/DeptAdd.vue'], r),
  },
  // 修改机构
  {
    path: '/deptMng',
    name: 'DeptMng',
    component: r => require(['../views/list/DeptMng.vue'], r),
  },
  // 看板维护
  {
    path: '/kanbanMng',
    name: 'KanbanMng',
    component: r => require(['../views/list/KanbanMng.vue'], r),
  },
  // 密码重置
  {
    path: '/pwdReset',
    name: 'PwdReset',
    component: r => require(['../views/list/PwdReset.vue'], r),
  },
  // 显示模板设计
  {
    path: '/screenTmpl',
    name: 'ScreenTmpl',
    component: r => require(['../views/list/ScreenTmpl.vue'], r),
  },
  
  // 网页看板
  {
    path: '/webKanban',
    name: 'WebKanban',
    component: r => require(['../views/system/WebKanban.vue'], r),
  },
  // 可见菜单
  {
    path: '/menuVisible',
    name: 'MenuVisible',
    component: r => require(['../views/system/MenuVisible.vue'], r),
  },
  // 权限分配
  {
    path: '/menuAssign',
    name: 'MenuAssign',
    component: r => require(['../views/system/MenuAssign.vue'], r),
  },
  // 参数配置
  {
    path: '/paramMng',
    name: 'ParamMng',
    component: r => require(['../views/system/ParamMng.vue'], r),
  },
  // 在线升级
  {
    path: '/onlineUpdate',
    name: 'OnlineUpdate',
    component: r => require(['../views/system/OnlineUpdate.vue'], r),
  },
  // 线程管理
  {
    path: '/threadMng',
    name: 'ThreadMng',
    component: r => require(['../views/system/ThreadMng.vue'], r),
  },
  // 操作日志
  {
    path: '/operLog',
    name: 'OperLog',
    component: r => require(['../views/system/OperLog.vue'], r),
  },
  // 更换LOGO
  {
    path: '/changeLogo',
    name: 'ChangeLogo',
    component: r => require(['../views/system/ChangeLogo.vue'], r),
  },
  // 不规则屏设置
  {
    path: '/complexScreen',
    name: 'ComplexScreen',
    component: r => require(['../views/system/ComplexScreen.vue'], r),
  },
  // 在线用户
  {
    path: '/loginMonitor',
    name: 'LoginMonitor',
    component: r => require(['../views/system/LoginMonitor.vue'], r),
  },
  // Hello
  {
    path: '/hello',
    name: 'Hello',
    component: r => require(['../views/system/Hello.vue'], r),
  },

  // 设备信息
  {
    path: '/equipment',
    name: 'Equipment',
    component: r => require(['../views/Equipment.vue'], r),
  },
  // 用户管理
  {
    path: '/user',
    name: 'User',
    component: r => require(['../views/User.vue'], r),
  },
  // 路由重定向
  {
    path: '*',
    redirect: {
      name: 'Login'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
